import { render, staticRenderFns } from "./WorkLoadAdmin.vue?vue&type=template&id=cb29b660&scoped=true&"
import script from "./WorkLoadAdmin.vue?vue&type=script&lang=js&"
export * from "./WorkLoadAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb29b660",
  null
  
)

export default component.exports